import { CopyListOrSegment } from '@/components/Contacts/CommonActions/CopyListOrSegment';
import { useSelectedEntity } from '@/components/Contacts/Group/hooks';
import { HideDialog, ShowDialog } from '@/store/dialog/actions';
import { ShowDialogParams } from '@/store/dialog/types';
import { ListAddStart } from '@/store/lists/actions';
import { SegmentAddStart } from '@/store/segments/actions';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

export const useCopyEntity = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch<any>();
    const { isSelectedEntityAList, selectedEntity } = useSelectedEntity();
    const isList = isSelectedEntityAList(selectedEntity);

    const copyListOrSegment = (): void => {
        let newEntity;
        let newEntityName;

        if (isList) {
            newEntity = {
                ListName: `${selectedEntity?.ListName} ${t('copy')}`,
                Rule: `List = '${selectedEntity?.ListName}'`,
            };
            newEntityName = newEntity.ListName;
        } else {
            newEntity = {
                Name: `${selectedEntity?.Name} ${t('copy')}`,
                rule: selectedEntity?.Rule,
            };
            newEntityName = newEntity.Name;
        }

        const updateSelectedName = (inputName): void => {
            newEntityName = inputName;
        };

        const params: ShowDialogParams = {
            title: isList ? t('copylist') : t('copysegment'),
            confirmLabel: t('copy'),
            onClickConfirm: (): void => {
                isList
                    ? dispatch(ListAddStart({ ...newEntity, ListName: newEntityName })).then(() =>
                          dispatch(HideDialog())
                      )
                    : dispatch(SegmentAddStart(newEntityName, newEntity.rule)).then(() => dispatch(HideDialog()));
            },
            cancelLabel: t('cancel'),
            isDisabled: newEntity.Error,
            body: <CopyListOrSegment selected={newEntity} isList={isList} onChange={updateSelectedName} />,
            isHiddenManually: true,
        };

        dispatch(ShowDialog(params));
    };

    return { copyListOrSegment };
};
